import {createSettingsContext as $eik1J$createSettingsContext} from "@macrostrat/ui-components";


// This will eventually help us move to "@macrostrat/ui-components" for settings provision
const [$b9d7b3b9bd11faad$export$e134aa690da9cc14, $b9d7b3b9bd11faad$export$9115b42802a3e44f, $b9d7b3b9bd11faad$var$useSettingsUpdater] = (0, $eik1J$createSettingsContext)({});
// Deprecated: this is kind of confusing
const $b9d7b3b9bd11faad$export$f558026a994b6051 = function(func) {
    // Update settings using `immutability-helper` semantics
    const updater = $b9d7b3b9bd11faad$var$useSettingsUpdater();
    return function() {
        return updater(func(...arguments));
    };
};


//# sourceMappingURL=settings.fd67daa2.js.map
